// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Rajdhani:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── NightScan HUD — CSS Variables ─────────────────── */
:root {
  --primary-900: #0a1628;
  --primary-800: #0d1f3c;
  --primary-700: #122a52;
  --primary-600: #1a3a5c;
  --primary-500: #1e4976;
  --primary-400: #2563a8;
  --primary-300: #3b82c4;
  --primary-200: #93c5e8;
  --primary-100: #dbeafe;
  --primary-50: #eff6ff;
  --primary: #1e4976;
  --primary-dark: #0a1628;
  --primary-light: #dbeafe;
  --primary-rgb: 30, 73, 118;
  --neon-500: #2563a8;

  --gold-500: #c8a437;
  --gold-400: #d4b44a;
  --gold-300: #e0c870;
  --gold-100: #fef9e7;

  --dark: #0a0e1a;
  --surface: #ffffff;
  --surface-1: #ffffff;
  --surface-rgb: 255, 255, 255;
  --surface-1-rgb: 255, 255, 255;
  --surface-2: #f8fafd;
  --surface-3: #f0f4f8;
  --border: #e2e8f0;
  --border-2: #cbd5e1;
  --text-primary: #0f172a;
  --text-secondary: #475569;
  --text-muted: #94a3b8;

  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;
  --info: #3b82f6;

  --radius-sm: 6px;
  --radius: 10px;
  --radius-lg: 16px;
  --radius-xl: 24px;

  --shadow-sm: 0 1px 3px rgba(10, 22, 40, 0.1);
  --shadow: 0 4px 12px rgba(10, 22, 40, 0.12);
  --shadow-lg: 0 8px 30px rgba(10, 22, 40, 0.15);
  --shadow-xl: 0 20px 60px rgba(10, 22, 40, 0.2);

  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --sidebar-width: 260px;
  --glass: rgba(255, 255, 255, 0.7);
  --glass-border: rgba(255, 255, 255, 0.3);
}

/* ─── Reset & Base ─────────────────────────────────── */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
  font-size: 16px;
  -webkit-text-size-adjust: 100%;
}

@media (max-width: 768px) {
  html {
    font-size: 17px;
  }
}

@media (max-width: 480px) {
  html {
    font-size: 19px;
    /* Very large base for absolute readability */
  }
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--surface-2);
  color: var(--text-primary);
  line-height: 1.6;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  
  background-attachment: fixed;
}

a {
  color: inherit;
  text-decoration: none;
}

button {
  cursor: pointer;
  border: none;
  outline: none;
}

input,
select,
textarea {
  font-family: inherit;
  outline: none;
}

img {
  max-width: 100%;
}

/* ─── Scrollbar ─────────────────────────────────────── */
::-webkit-scrollbar { width: 4px; height: 4px; }
::-webkit-scrollbar-track { background: var(--surface-2); }
::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.3); border-radius: 10px; }
::-webkit-scrollbar-thumb:hover { background: rgba(0,212,255,0.6); }

/* ─── Login Page — Dark Scanner ────────────────────── */
.login-page {
  min-height: 100vh;
  background: var(--surface-2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  position: relative;
  overflow: hidden;
}

/* Animated grid background */
.login-page::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(0,212,255,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(0,212,255,0.05) 1px, transparent 1px);
  background-size: 60px 60px;
  animation: gridPan 30s linear infinite;
  z-index: 0;
}

/* Neon orb glow */
.login-page::after {
  content: '';
  position: absolute;
  width: 600px;
  height: 600px;
  top: -200px;
  right: -200px;
  background: radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%);
  z-index: 0;
  animation: orbFloat 12s ease-in-out infinite alternate;
}

@keyframes gridPan {
  0%   { background-position: 0 0; }
  100% { background-position: 60px 60px; }
}
@keyframes orbFloat {
  from { transform: translate(0,0) scale(1); }
  to   { transform: translate(-40px, 40px) scale(1.1); }
}

.login-card {
  position: relative;
  z-index: 1;
  background: rgba(6, 14, 30, 0.85);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  width: 100%;
  max-width: 460px;
  padding: 52px 44px;
  border-radius: var(--radius-xl);
  box-shadow: 0 0 0 1px var(--border), var(--shadow-xl);
  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  border: 1px solid var(--glass-border);
  color: var(--text-primary);
}

/* Corner HUD brackets */
.login-card::before,
.login-card::after {
  content: '';
  position: absolute;
  width: 24px;
  height: 24px;
  border-color: var(--neon-500);
  border-style: solid;
  opacity: 0.8;
}
.login-card::before { top: 16px; left: 16px; border-width: 2px 0 0 2px; }
.login-card::after  { bottom: 16px; right: 16px; border-width: 0 2px 2px 0; }

.login-logo {
  text-align: center;
  margin-bottom: 36px;
}
.login-logo-container {
  display: inline-block;
  margin-bottom: 16px;
}
.login-logo h1 {
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
  margin-bottom: 6px;
}
.login-logo p {
  color: var(--text-secondary);
  font-size: 13px;
}
.login-info-box {
  text-align: center;
  margin-top: 28px;
  padding: 14px;
  background: rgba(0,212,255,0.04);
  border-radius: var(--radius);
  border: 1px solid var(--glass-border);
}
.login-info-box span { color: var(--neon-500) !important; }
.login-info-box p    { color: var(--text-secondary) !important; }

/* Login inputs */
.login-card .form-label {
  color: var(--neon-500);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
}
.login-card .form-control {
  background: rgba(0,212,255,0.05);
  border: 1px solid var(--border);
  padding: 13px 16px;
  font-size: 14px;
  border-radius: var(--radius);
  transition: all 0.3s ease;
  color: var(--text-primary);
}
.login-card .form-control:focus {
  background: rgba(0,212,255,0.08);
  border-color: var(--neon-500);
  box-shadow: 0 0 0 3px rgba(0,212,255,0.12), var(--neon-glow-sm);
}
.login-card .form-control::placeholder { color: var(--text-muted); }

.login-card .btn-primary {
  height: 52px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  background: linear-gradient(135deg, var(--neon-600), var(--neon-500));
  color: #020812;
  border: none;
  box-shadow: var(--neon-glow);
  transition: all 0.3s ease;
  font-family: 'Rajdhani', sans-serif;
}
.login-card .btn-primary:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 0 30px rgba(0,212,255,0.6), 0 0 60px rgba(0,212,255,0.25);
}


/* Premium Animations */
@keyframes premiumFloat {

  0%,
  100% {
    transform: translateY(0) rotate(-5deg);
  }

  50% {
    transform: translateY(-12px) rotate(-5deg);
  }
}

/* Plus Button Animation Enhancement */
.plus-btn-animated {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  cursor: pointer;
}

.plus-btn-animated:hover {
  transform: scale(1.15) !important;
  box-shadow: 0 20px 40px rgba(37, 99, 168, 0.4) !important;
  filter: brightness(1.2) contrast(1.1);
}

.plus-btn-animated:hover svg {
  animation: svgSpin 0.7s cubic-bezier(0.68, -0.55, 0.27, 1.55);
}

@keyframes svgSpin {
  0% { transform: rotate(0deg) scale(1); }
  50% { transform: rotate(180deg) scale(1.4); }
  100% { transform: rotate(360deg) scale(1); }
}

/* Subtle continuous rotation for objects */
.slow-rotate {
  animation: slowRotate 30s linear infinite;
}

@keyframes slowRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes premiumPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0.4);
  }

  70% {
    box-shadow: 0 0 0 20px rgba(var(--primary-rgb), 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0);
  }
}

@keyframes rotateIcon {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ─── App Layout ───────────────────────────────── */
.app-layout {
  display: flex;
  min-height: 100vh;
}

/* ─── Sidebar ───────────────────────────────── */
.sidebar {
  width: var(--sidebar-width);
  background: #0a1628; /* Solid, deep professional blue */
  border-right: 1px solid rgba(255,255,255,0.05);
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  height: 100dvh;
  z-index: 100;
  transition: var(--transition);
  box-shadow: 10px 0 40px rgba(0,0,0,0.3);
}

.sidebar-nav {
  flex: 1 1;
  padding: 15px 12px;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
  position: relative;
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nav-group { margin-bottom: 6px; }

.nav-group-label {
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2.5px;
  color: rgba(255,255,255,0.3);
  padding: 18px 14px 8px;
  font-family: 'Inter', sans-serif;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  color: rgba(255,255,255,0.6);
  font-size: 13px;
  font-weight: 500;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  margin-bottom: 4px;
  text-decoration: none;
  position: relative;
  overflow: hidden;
}

.nav-item:hover {
  background: rgba(212, 175, 55, 0.08);
  color: var(--gold-300);
}

.nav-item.active {
  background: linear-gradient(90deg, rgba(212, 175, 55, 0.15) 0%, transparent 100%);
  color: var(--gold-400);
  border-left: 3px solid var(--gold-500);
  font-weight: 600;
}

.nav-item.active .nav-icon {
  color: var(--gold-500);
  filter: drop-shadow(0 0 8px rgba(212, 175, 55, 0.4));
}

.nav-item .nav-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  opacity: 0.8;
  transition: all 0.2s ease;
}

.nav-item:hover .nav-icon {
  opacity: 1;
  transform: scale(1.1);
}

.nav-item .nav-badge {
  margin-left: auto;
  background: var(--gold-500);
  color: #071325;
  font-size: 10px;
  font-weight: 800;
  padding: 2px 6px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);
}

.sidebar-footer {
  padding: 16px 12px;
  border-top: 1px solid rgba(212, 175, 55, 0.15);
  background: rgba(255,255,255,0.03);
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: var(--transition);
}

.sidebar-user:hover { background: rgba(212, 175, 55, 0.08); }

.user-avatar {
  width: 34px;
  height: 34px;
  background: linear-gradient(135deg, var(--gold-500), var(--gold-400));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0a1628;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  box-shadow: 0 0 12px rgba(212, 175, 55, 0.25);
}

.user-info {
  flex: 1 1;
  min-width: 0;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: white;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 10px;
  color: var(--gold-400);
  opacity: 0.7;
}

/* ─── Main Content ────────────────────────────────── */
.main-content {
  margin-left: var(--sidebar-width);
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: var(--surface-2);
  transition: var(--transition);
  
}

/* ─── Topbar ─────────────────────────────────────── */
.topbar {
  background: var(--surface-2);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--glass-border);
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: 0 1px 0 var(--border), 0 4px 20px rgba(0,0,0,0.4);
}

.topbar-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text-primary);
  font-family: 'Rajdhani', sans-serif;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.topbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.topbar-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
}

.topbar-btn-ghost {
  background: transparent;
  color: var(--text-secondary);
}

.topbar-btn-ghost:hover {
  background: var(--surface-3);
  color: var(--primary-600);
}

/* ─── Page Content ────────────────────────────────── */
.page-content {
  flex: 1 1;
  padding: 40px 60px; /* Decent breathable padding */
  max-width: 1540px;
  margin: 0 auto;
  width: 100%;
  min-height: calc(100vh - 72px);
  position: relative;
  transition: var(--transition);
}

@media (max-width: 1200px) {
  .page-content {
      padding: 30px 30px;
  }
}

@media (max-width: 768px) {
  .page-content {
      padding: 20px 16px;
  }
}

/* ─── Stats Cards ───────────────────────────── */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface-3) 100%);
  border-radius: var(--radius-lg);
  padding: 22px;
  border: 1px solid var(--glass-border);
  transition: var(--transition);
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
}

/* top accent line */
.stat-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 2px;
}
.stat-card.blue::before  { background: linear-gradient(90deg, var(--neon-500), transparent); }
.stat-card.gold::before  { background: linear-gradient(90deg, var(--gold-500), transparent); }
.stat-card.green::before { background: linear-gradient(90deg, var(--success), transparent); }
.stat-card.red::before   { background: linear-gradient(90deg, var(--danger), transparent); }
.stat-card.purple::before{ background: linear-gradient(90deg, #8b5cf6, transparent); }

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: var(--shadow);
  border-color: rgba(0,212,255,0.3);
}

.stat-icon {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}
.stat-icon.blue   { background: rgba(37, 99, 168, 0.1);  color: var(--primary-500); }
.stat-icon.gold   { background: var(--gold-100);        color: var(--gold-400); }
.stat-icon.green  { background: #ecfdf5;                color: var(--success); }
.stat-icon.purple { background: #f5f3ff;                color: #7c3aed; }
.stat-icon.green  { background: rgba(0,255,170,0.1);   color: var(--success); }
.stat-icon.red    { background: rgba(255,68,102,0.1);  color: var(--danger); }

.stat-number {
  font-size: 28px;
  font-weight: 800;
  color: var(--text-primary);
  font-family: 'Rajdhani', sans-serif;
  letter-spacing: 1px;
}

.stat-label {
  font-size: 11px;
  color: var(--text-muted);
  font-weight: 600;
  margin-top: 2px;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

/* ─── Dashboard extension cards ─────────────────── */
.glass-panel {
  background: var(--glass);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid var(--glass-border);
  border-radius: var(--radius-lg);
}
.premium-stat {
  background: var(--surface-2);
  padding: 24px;
  border-radius: 20px;
  border: 1px solid var(--glass-border);
  transition: var(--transition);
}
.premium-stat:hover { transform: translateY(-5px); box-shadow: var(--shadow-lg); }

.card {
  background: white;
  color: var(--text-primary);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
  border-radius: var(--radius-lg);
  transition: var(--transition);
  padding: 24px;
}

.card:hover {
  box-shadow: var(--shadow);
}


.insight-card { background: white; color: var(--text-primary); border: 1px solid var(--border); box-shadow: var(--shadow-sm); position: relative; overflow: hidden; border-radius: var(--radius-lg); }

.gold-glow { box-shadow: 0 0 15px rgba(200, 164, 55, 0.15); border: 1px solid rgba(200, 164, 55, 0.3); border-radius: var(--radius-lg); }
.rank-item {
  display: flex; align-items: center; gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border-2);
}
.rank-item:last-child { border-bottom: none; }
.rank-number {
  width: 24px; height: 24px;
  border-radius: 6px;
  background: var(--surface-3);
  display: flex; align-items: center; justify-content: center;
  font-size: 11px; font-weight: 800; color: var(--neon-500);
}
.rank-count { margin-left: auto; font-weight: 700; font-size: 13px; color: var(--neon-500); }

.gold-glow { box-shadow: 0 0 15px rgba(200, 164, 55, 0.15); border: 1px solid rgba(200, 164, 55, 0.3); border-radius: var(--radius-lg); }

.rank-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--surface-2);
}

.rank-item:last-child {
    border-bottom: none;
}

.compact-table {
  width: 100%;
  border-collapse: collapse;
}

.compact-table th {
  font-size: 10px;
  text-transform: uppercase;
  color: var(--text-muted);
  padding: 8px 4px;
  border-bottom: 1px solid var(--border);
  text-align: left;
}

.compact-table td {
  padding: 8px 4px;
  border-bottom: 1px solid var(--surface-2);
  vertical-align: middle;
}

.compact-table tr:last-child td {
  border-bottom: none;
}

.rank-number {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    background: var(--surface-3);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 800;
    color: var(--text-muted);
}

.rank-count {
    margin-left: auto;
    font-weight: 700;
    font-size: 13px;
    color: var(--primary-600);
}


/* ─── Buttons ────────────────────────────────────── */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 600;
  transition: var(--transition);
  cursor: pointer;
  border: none;
  white-space: nowrap;
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btn-primary {
  background: linear-gradient(135deg, var(--primary-600), var(--primary-500));
  color: white;
  box-shadow: 0 4px 12px rgba(26, 58, 92, 0.3);
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, var(--primary-700), var(--primary-600));
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(26, 58, 92, 0.4);
}

.btn-gold {
  background: linear-gradient(135deg, #d4af37 0%, #f1c40f 100%);
  color: #1a1a1a;
  font-weight: 700;
  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.btn-gold:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4);
  background: linear-gradient(135deg, #f1c40f 0%, #d4af37 100%);
}

.btn-pdf {
  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);
  color: white;
  font-weight: 700;
  border: none;
  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  z-index: 1;
}

.btn-pdf:hover:not(:disabled) {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 12px 28px rgba(231, 76, 60, 0.45);
}

.btn-pdf::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent);
  transition: all 0.6s ease;
}

.btn-pdf:hover::before {
  left: 100%;
}

.btn-pdf svg {
  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.5));
}

.btn-outline {
  background: transparent;
  color: var(--primary-600);
  border: 1.5px solid var(--primary-300);
}

.btn-outline:hover:not(:disabled) {
  background: var(--primary-50);
  border-color: var(--primary-500);
}

.btn-danger {
  background: var(--danger);
  color: white;
}

.btn-danger:hover:not(:disabled) {
  background: #dc2626;
  transform: translateY(-1px);
}

.btn-ghost {
  background: transparent;
  color: var(--text-secondary);
}

.btn-ghost:hover {
  background: var(--surface-3);
  color: var(--text-primary);
}

.btn-sm {
  padding: 6px 12px;
  font-size: 13px;
}

.btn-lg {
  padding: 12px 24px;
  font-size: 16px;
}

.btn-circle {
  border-radius: 50% !important;
  aspect-ratio: 1 / 1;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* ─── Forms ──────────────────────────────────────── */
.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
}

.form-control {
  width: 100%;
  padding: 10px 14px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  color: var(--text-primary);
  background: white;
  transition: var(--transition);
}

.form-control:focus {
  border-color: var(--primary-400);
  box-shadow: 0 0 0 3px rgba(37, 99, 168, 0.1);
}

.form-control::placeholder {
  color: var(--text-muted);
}

.form-error {
  font-size: 12px;
  color: var(--danger);
  margin-top: 4px;
}

.form-hint {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 4px;
}

.form-grid {
  display: grid;
  gap: 24px;
  padding: 0 20px 24px 20px;
}

.form-grid-2 {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
}

.form-grid-3 {
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
}

.form-section {
  margin-bottom: 24px;
}

.form-section-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary-700);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 14px 24px;
  background: linear-gradient(90deg, var(--primary-50), transparent);
  border-left: 3px solid var(--primary-400);
  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  margin-bottom: 24px;
}

/* ─── Grid Utilities ────────────────────────────────── */
.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
}

@media (max-width: 900px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
}

/* ─── Tables ─────────────────────────────────────── */
.table-responsive {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-container {
  background: white;
  border-radius: var(--radius); box-shadow: var(--shadow-sm);
  border: 1px solid var(--border);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-2);
  background: white;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background: var(--surface-2);
}

th {
  padding: 12px 16px;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-muted);
  white-space: nowrap;
  border-bottom: 2px solid var(--border);
}

td {
  padding: 14px 16px;
  font-size: 14px;
  border-bottom: 1px solid var(--border-2);
  color: var(--text-primary);
}

tbody tr:hover {
  background: var(--surface-2);
}

tbody tr:last-child td {
  border-bottom: none;
}

.table-actions {
  display: flex;
  gap: 4px;
}

.table-actions .btn-ghost {
  padding: 8px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.table-actions .btn-ghost svg,
.table-actions .btn-ghost i {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.action-view {
  color: var(--text-secondary);
}

.action-view:hover {
  background: var(--primary-50) !important;
  color: var(--primary-500) !important;
}

.action-edit {
  color: var(--text-secondary);
}

.action-edit:hover {
  background: #fef3c7 !important;
  color: #d97706 !important;
}

.action-invoice {
  color: var(--primary-600);
}

.action-invoice:hover {
  background: #dcfce7 !important;
  color: var(--success) !important;
}

.action-pdf {
  color: var(--primary-600);
}

.action-pdf:hover {
  background: var(--primary-100) !important;
  color: var(--primary-800) !important;
}

.action-export {
  color: var(--primary-700);
}

.action-export:hover {
  background: var(--gold-100) !important;
  color: #b45309 !important;
}

.action-delete {
  color: var(--danger);
}

.action-delete:hover {
  background: #fee2e2 !important;
  color: #b91c1c !important;
}

/* ─── Badges / Status ────────────────────────────── */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.badge-blue {
  background: var(--primary-100);
  color: var(--primary-600);
}

.badge-gold {
  background: var(--gold-100);
  color: #8a6c00;
}

.badge-green {
  background: #d1fae5;
  color: #065f46;
}

.badge-red {
  background: #fee2e2;
  color: #991b1b;
}

.badge-gray {
  background: var(--surface-3);
  color: var(--text-secondary);
}

.badge-orange {
  background: #fff7ed;
  color: #9a3412;
}

/* ─── Modals ─────────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 22, 40, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
  animation: fadeIn 0.2s ease;
}

.modal {
  background: white;
  border-radius: var(--radius-lg);
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: var(--shadow-xl);
  animation: slideUp 0.3s ease;
}

.modal-lg {
  max-width: 900px;
}

.modal-xxl {
  max-width: 1700px;
  width: 96vw;
}

.premium-grid-layout {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

@media (max-width: 1400px) {
  .premium-grid-layout {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 900px) {
  .premium-grid-layout {
    grid-template-columns: 1fr;
  }
}

/* Premium Form Elements */
.premium-card {
  background: var(--surface-1);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
  overflow: hidden;
}

.premium-card:hover {
  box-shadow: var(--shadow-md);
  border-color: var(--primary-light);
}

.premium-header {
  padding: 12px 16px;
  background: var(--surface-1);
  border-bottom: 1px solid var(--border-2);
  display: flex;
  align-items: center;
  gap: 10px;
}

.premium-header i,
.premium-header svg {
  color: var(--primary);
  filter: drop-shadow(0 2px 4px rgba(var(--primary-rgb), 0.2));
}

.premium-header span {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text-primary);
}

.premium-input-group {
  position: relative;
  margin-bottom: 0;
}

.premium-input-group .form-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
  margin-bottom: 4px;
  display: block;
}

.premium-input-group .form-control {
  border-radius: 8px;
  border: 1.5px solid var(--border);
  background: var(--surface-2);
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.premium-input-group .form-control:focus {
  border-color: var(--primary);
  background: var(--surface-1);
  box-shadow: 0 0 0 4px rgba(var(--primary-rgb), 0.1);
}

/* ─── Toggle Switch ─────────────────────────────────── */
.form-toggle {
  width: 44px;
  height: 22px;
  background: #cbd5e1;
  border-radius: 100px;
  position: relative;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border: 1px solid rgba(0,0,0,0.05);
}

.form-toggle.active {
  background: var(--gold-500);
}

.toggle-dot {
  width: 16px;
  height: 16px;
  background: #ffffff;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 3px;
  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.form-toggle.active .toggle-dot {
  left: calc(100% - 19px);
}

.glass-modal {
  backdrop-filter: blur(15px);
  background: rgba(var(--surface-1-rgb), 0.8);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 24px;
  border-bottom: 1px solid var(--border-2);
  flex-shrink: 0;
}

.modal-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--primary-800);
}

.modal-body {
  padding: 24px;
  overflow-y: auto;
  flex: 1 1;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

.modal-close {
  background: var(--surface-3);
  color: var(--text-secondary);
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition);
}

.modal-close:hover {
  background: var(--border);
  color: var(--text-primary);
}

/* ─── Search & Filters ────────────────────────────── */
.search-box {
  position: relative;
  display: flex;
  align-items: center;
}

.search-box input {
  padding: 8px 14px 8px 36px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-size: 14px;
  background: var(--surface-2);
  width: 260px;
  transition: var(--transition);
}

.search-box input:focus {
  border-color: var(--primary-400);
  background: white;
  width: 320px;
  box-shadow: 0 0 0 3px rgba(37, 99, 168, 0.1);
}

.search-icon {
  position: absolute;
  left: 10px;
  color: var(--text-muted);
}

/* ─── Pieces Table (Rapport) ─────────────────────── */
.pieces-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
}

.pieces-table th {
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.9);
  color: white;
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}

.pieces-table td {
  padding: 6px 8px;
  border-bottom: 1px solid var(--border-2);
}

.pieces-table tbody tr:hover {
  background: var(--primary-50);
}

.pieces-input {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid var(--border);
  border-radius: 4px;
  font-size: 13px;
  background: transparent;
}

.pieces-input:focus {
  border-color: var(--primary-400);
  background: white;
}

.pieces-subtotal {
  font-weight: 700;
  color: var(--primary-600);
  font-size: 14px;
}

/* ─── Photo Upload ───────────────────────────────── */
.dropzone {
  border: 2px dashed var(--border-2);
  border-radius: var(--radius);
  padding: 30px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
  background: var(--surface-2);
}

.dropzone:hover,
.dropzone.active {
  border-color: var(--primary-400);
  background: var(--primary-50);
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-top: 12px;
}

.photo-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: var(--radius-sm);
  overflow: hidden;
  border: 2px solid var(--border);
}

.photo-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-delete {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(239, 68, 68, 0.9);
  color: white;
  border: none;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
}

/* ─── Empty State ────────────────────────────────── */
.empty-state {
  text-align: center;
  padding: 48px 24px;
  color: var(--text-muted);
}

.empty-state-icon {
  font-size: 48px;
  margin-bottom: 12px;
  opacity: 0.5;
}

.empty-state h3 {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-secondary);
  margin-bottom: 6px;
}

.empty-state p {
  font-size: 14px;
}

/* ─── Loading ────────────────────────────────────── */
.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
}

.spinner {
  width: 36px;
  height: 36px;
  border: 3px solid var(--border);
  border-top-color: var(--primary-500);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.skeleton {
  background: linear-gradient(90deg, var(--surface-3) 25%, var(--border) 50%, var(--surface-3) 75%);
  background-size: 400% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: var(--radius-sm);
}

/* ─── Pagination ─────────────────────────────────── */
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 16px;
}

.page-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm);
  font-size: 14px;
  font-weight: 500;
  transition: var(--transition);
  border: 1px solid var(--border);
  background: white;
  cursor: pointer;
  color: var(--text-secondary);
}

.page-btn:hover {
  border-color: var(--primary-400);
  color: var(--primary-500);
  background: var(--primary-50);
}

.page-btn.active {
  background: var(--primary-600);
  color: white;
  border-color: var(--primary-600);
}

.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ─── Tabs ──────────────────────────────────────── */
.tabs {
  display: flex;
  border-bottom: 2px solid var(--border);
  margin-bottom: 20px;
}

.tab {
  padding: 10px 18px;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: var(--transition);
}

.tab:hover {
  color: var(--primary-600);
}

.tab.active {
  color: var(--primary-600);
  border-bottom-color: var(--primary-500);
  background: var(--primary-50);
}

/* ─── Dashboard Quick Actions ─────────────────────── */
.quick-actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
}

.quick-action-card {
  background: white;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
}

.quick-action-card:hover {
  border-color: var(--primary-400);
  background: var(--primary-50);
  transform: translateY(-2px);
  box-shadow: var(--shadow);
}

.quick-action-icon {
  width: 48px;
  height: 48px;
  border-radius: var(--radius);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.quick-action-label {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

/* ─── Animations ─────────────────────────────────── */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes shimmer {
  to {
    background-position: -400% 0;
  }
}

/* ─── Mobile Overlay ─────────────────────────────── */
.sidebar-overlay {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99;
}

.menu-toggle {
  display: none;
  background: transparent;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
}

/* ─── Responsive ─────────────────────────────────── */
@media (max-width: 1024px) {
  .form-grid-3 {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }

  .grid-3 {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    z-index: 200;
  }

  .sidebar.open {
    transform: translateX(0);
  }

  .sidebar-overlay {
    display: block;
  }

  .main-content {
    margin-left: 0;
    padding-top: 0;
  }

  .menu-toggle {
    display: flex;
  }

  .form-grid-2,
  .form-grid-3,
  .grid-2,
  .grid-3 {
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 12px !important;
  }

  .search-box input {
    width: 100%;
  }

  .stats-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    padding: 0;
    margin-bottom: 16px;
  }

  .stat-card {
    padding: 16px;
  }

  .topbar-date {
    display: none;
  }

  .header-custom-actions {
    margin-right: -10px;
    display: flex;
    align-items: center;
  }

  .sidebar {
    height: 100dvh !important;
    display: flex !important;
    flex-direction: column !important;
    padding-bottom: 0 !important;
    /* No padding here anymore */
  }

  .sidebar-nav {
    flex: 1 1 !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch !important;
  }

  .sidebar-footer {
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    /* Support for modern phones */
  }


  .stat-number {
    font-size: 20px;
  }

  .page-content {
    padding: 10px;
  }

  .quick-actions-grid {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }

  .modal {
    max-width: 95%;
    max-height: 90vh;
    border-radius: var(--radius);
  }

  .modal-overlay {
    padding: 10px;
    align-items: center;
  }

  .table-container {
    margin: 0 -12px;
    padding: 0 12px;
    width: calc(100% + 24px);
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  table {
    min-width: 500px;
  }

  .card-header {
    flex-direction: row;
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .topbar {
    padding: 12px 16px;
    height: 64px;
  }

  .topbar-title {
    font-size: 18px;
  }

  .topbar-actions {
    display: flex;
    align-items: center;
  }

  th,
  td {
    padding: 12px 10px;
    font-size: 13px;
  }

  .btn {
    padding: 14px 20px;
    font-size: 15px;
    width: 100%;
    justify-content: center;
    min-height: 48px;
  }

  /* Prevent topbar buttons from being full width */
  .topbar-actions .btn,
  .header-custom-actions .btn {
    width: auto;
    min-height: unset;
    padding: 8px;
  }

  .card {
    padding: 16px;
    margin-bottom: 16px;
  }

  .card-title {
    font-size: 16px;
  }

  .form-label {
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: 700;
  }

  .form-control {
    padding: 12px 16px;
    font-size: 15px;
    border-width: 2px;
  }

  .quick-actions-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .login-card {
    padding: 40px 24px;
    border-radius: 0;
    min-height: 100vh;
  }

  .login-logo p {
    font-size: 15px;
  }

  /* Universal minimums for mobile readability */
  label,
  .form-label,
  .nav-group-label,
  .card-title {
    font-size: 14px !important;
  }

  .badge,
  .text-sm,
  .text-muted {
    font-size: 13px !important;
  }

  /* Fix small fonts in inline styles often used in cards */
  div[style*="font-size: 11px"],
  div[style*="font-size: 10px"],
  span[style*="font-size: 11px"],
  span[style*="font-size: 10px"] {
    font-size: 13px !important;
  }

  div[style*="font-size: 13px"],
  div[style*="font-size: 12px"] {
    font-size: 15px !important;
  }
}

/* ─── Print ──────────────────────────────────────── */
@media print {

  .sidebar,
  .topbar {
    display: none;
  }

  .main-content {
    margin-left: 0;
  }
}

/* ─── Utility Classes ────────────────────────────── */
.flex {
  display: flex;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

@media (max-width: 768px) {
  .flex-between {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.gap-4 {
  gap: 16px;
}

.mb-4 {
  margin-bottom: 16px;
}

.mb-6 {
  margin-bottom: 24px;
}

.mt-4 {
  margin-top: 16px;
}

.text-sm {
  font-size: 12px;
}

.text-muted {
  color: var(--text-muted);
}

.text-success {
  color: var(--success);
}

.text-danger {
  color: var(--danger);
}

.text-gold {
  color: var(--gold-500);
}

.font-bold {
  font-weight: 700;
}

.w-full {
  width: 100%;
}

.grid-2 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}

.grid-3 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
}

@media (max-width: 480px) {

  .grid-2,
  .grid-3 {
    grid-template-columns: minmax(0, 1fr) !important;
  }
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }

  50% {
    transform: scale(1.4);
    opacity: 0.3;
  }

  100% {
    transform: scale(1.8);
    opacity: 0;
  }
}

@keyframes slideInDown {
  from {
    transform: translateY(-10px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.template-suggestions-container {
  animation: slideInDown 0.3s ease-out;
}

/* ─── IA Style Enhancements ─── */
.btn-ia {
  background: linear-gradient(135deg, #6366f1, #a855f7) !important;
  color: white !important;
  border: none !important;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
  z-index: 1;
}

.btn-ia:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.45);
  filter: brightness(1.1);
}

.btn-ia:active:not(:disabled) {
  transform: translateY(1px) scale(0.98);
}

.btn-ia::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent);
  transition: all 0.6s;
  z-index: -1;
}

.btn-ia:hover::before {
  left: 100%;
}

.badge-ia-cool {
  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;
  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);
  animation: ia-pulse 2s infinite ease-in-out;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

@keyframes ia-pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }

  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.spinner-ia {
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top: 2px solid #ffffff;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  animation: spin-ia 0.8s linear infinite;
}

@keyframes spin-ia {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/* ─── Modal / Dialog ─────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9000;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  padding: 24px;
}

.modal {
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-xl);
  width: 100%;
  max-width: 500px;
  position: relative;
}

/* ─── Animations ─────────────────────────────────── */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.97);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes imgFadeIn {
  from {
    opacity: 0;
    transform: scale(0.96);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes premiumPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0.4);
    transform: scale(1);
  }

  50% {
    box-shadow: 0 0 0 15px rgba(var(--primary-rgb), 0);
    transform: scale(1.02);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0);
    transform: scale(1);
  }
}

@keyframes pointingArrow {

  0%,
  100% {
    transform: translateX(0);
    opacity: 0.8;
  }

  50% {
    transform: translateX(12px);
    opacity: 1;
  }
}

/* ─── Collapsed Sidebar ────────────────────────────── */
:root {
  --sidebar-collapsed-width: 80px;
}

.sidebar.collapsed {
  width: var(--sidebar-collapsed-width);
}

.sidebar.collapsed .sidebar-header {
  padding: 20px 0 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar.collapsed .nav-group-label {
  display: none;
}

.sidebar.collapsed .nav-item {
  justify-content: center;
  padding: 11px 0;
  margin-bottom: 8px;
}

.sidebar.collapsed .nav-item span {
  display: none;
}

.sidebar.collapsed .nav-item .nav-badge { margin-left: auto; background: var(--gold-500); color: #071325; font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 10px; box-shadow: 0 0 10px rgba(212, 175, 55, 0.3); }

.sidebar.collapsed .sidebar-user {
  justify-content: center;
  padding: 8px 0;
}

.sidebar.collapsed .user-info,
.sidebar.collapsed .sidebar-user>svg {
  display: none;
}

.app-layout:has(.sidebar.collapsed) .main-content {
  margin-left: var(--sidebar-collapsed-width);
}

@media (max-width: 768px) {
  .app-layout:has(.sidebar.collapsed) .main-content {
    margin-left: 0;
  }
}

@media (max-width: 768px) {
  .desktop-collapse-btn {
    display: none !important;
  }
}

/* ─── Table Actions ────────────────────────────────── */
.table-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.table-actions .btn-ghost {
  padding: 6px;
  border-radius: 8px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-actions .btn-ghost:hover {
  background: var(--surface-3);
  transform: translateY(-1px);
}

.text-red { color: #ef4444 !important; }
.text-warning { color: #f59e0b !important; }
.text-success { color: #10b981 !important; }

/* ─── Premium Settings Redesign ────────────────────── */
.settings-container {
  display: flex;
  gap: 32px;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow);
  min-height: 600px;
  overflow: hidden;
  border: 1px solid var(--border);
}

.settings-sidebar {
  width: 280px;
  background: #f8fafc;
  border-right: 1px solid var(--border);
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.settings-nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 12px;
  color: var(--text-secondary);
  font-weight: 600;
  font-size: 14px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.settings-nav-item:hover {
  background: var(--primary-50);
  color: var(--primary-600);
}

.settings-nav-item.active {
  background: var(--surface-2);
  color: var(--gold-300);
  box-shadow: 0 4px 12px rgba(10, 22, 40, 0.2);
}

.settings-content {
  flex: 1 1;
  padding: 32px;
  overflow-y: auto;
  background: #fff;
}

.settings-section-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--primary-50);
}

.settings-title {
  font-size: 22px;
  font-weight: 800;
  color: var(--primary-900);
  letter-spacing: -0.5px;
}

.settings-card {
  background: white;
  border-radius: 16px;
  border: 1px solid var(--border);
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
  transition: transform 0.2s ease;
}

.settings-card:hover { border-color: var(--primary-200); }

.settings-card-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  color: var(--primary-800);
  margin-bottom: 20px;
}

.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.badge-ia-premium {
  background: linear-gradient(135deg, #6366f1, #a855f7);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
}

.btn-save-floating {
  position: fixed;
  bottom: 30px;
  right: 30px;
  padding: 16px 32px;
  border-radius: 50px;
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  animation: slideUp 0.5s ease;
}

@media (max-width: 1024px) {
  .settings-container { flex-direction: column; gap: 0; }
  .settings-sidebar { width: 100%; border-right: none; border-bottom: 1px solid var(--border-2); flex-direction: row; overflow-x: auto; padding: 12px; }
  .settings-nav-item { white-space: nowrap; }
}

/* ─── Premium Login Redesign (Google Stitch) ─────── */
.login-page-v2 {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background: #071325;
}

.login-bg-hero {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(rgba(7, 19, 37, 0.7), rgba(7, 19, 37, 0.95)), 
              url('https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&q=80&w=2070');
  background-size: cover;
  background-position: center;
  filter: contrast(1.1) brightness(0.8);
  animation: bg-zoom 60s infinite alternate linear;
}

@keyframes bg-zoom {
  0% { transform: scale(1); }
  100% { transform: scale(1.1); }
}

.login-bg-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, transparent 0%, rgba(7, 19, 37, 0.8) 100%);
}

.login-glow-1 {
  position: absolute;
  top: 20%;
  left: 10%;
  width: 400px;
  height: 400px;
  background: rgba(212, 175, 55, 0.05);
  border-radius: 50%;
  filter: blur(100px);
  animation: float-slow 15s infinite alternate;
}

.login-glow-2 {
  position: absolute;
  bottom: 20%;
  right: 10%;
  width: 400px;
  height: 400px;
  background: rgba(212, 175, 55, 0.05);
  border-radius: 50%;
  filter: blur(100px);
  animation: float-slow 12s infinite alternate-reverse;
}

@keyframes float-slow {
  from { transform: translate(0, 0); }
  to { transform: translate(40px, 40px); }
}

.glass-login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 440px;
  background: rgba(10, 22, 40, 0.75);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(212, 175, 55, 0.15);
  border-radius: 24px;
  padding: 48px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(212, 175, 55, 0.05);
  animation: slideUpFade 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.glass-login-card::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    45deg,
    transparent 45%,
    rgba(212, 175, 55, 0.1) 50%,
    transparent 55%
  );
  transform: rotate(45deg);
  animation: shimmer 4s infinite;
  pointer-events: none;
}

@keyframes shimmer {
  0% { transform: translate(-30%, -30%) rotate(45deg); }
  100% { transform: translate(30%, 30%) rotate(45deg); }
}

@keyframes slideUpFade {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}

.login-brand {
  text-align: center;
  margin-bottom: 30px;
}

.login-brand-logo {
    display: flex;
    justify-content: center;
    margin-bottom: -15px;
}

.login-brand h1 {
  font-size: 32px;
  font-weight: 800;
  color: var(--gold-400);
  letter-spacing: 4px;
  text-transform: uppercase;
  margin-bottom: 8px;
  filter: drop-shadow(0 0 10px rgba(212, 175, 55, 0.3));
  transition: filter 0.3s ease;
}

.login-brand:hover h1 {
  filter: drop-shadow(0 0 20px rgba(212, 175, 55, 0.6));
}

.login-brand-line {
  height: 1px;
  width: 60px;
  background: linear-gradient(90deg, transparent, var(--gold-500), transparent);
  margin: 0 auto 12px;
  animation: pulse-line 3s infinite ease-in-out;
}

@keyframes pulse-line {
  0%, 100% { opacity: 0.5; width: 60px; }
  50% { opacity: 1; width: 100px; }
}

.login-brand p {
  font-size: 10px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 600;
}

.login-form-group {
  margin-bottom: 24px;
}

.login-label {
  display: block;
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
  font-weight: 700;
}

.login-input-wrapper {
  position: relative;
}

.login-input-icon {
  position: absolute;
  left: 16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--gold-500);
  opacity: 0.6;
}

.login-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 14px 14px 14px 48px;
  color: white;
  font-size: 15px;
  transition: all 0.3s;
  outline: none;
}

.login-input:focus {
  background: rgba(255, 255, 255, 0.06);
  border-color: var(--gold-500);
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.1);
}

.login-btn {
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, var(--gold-500), var(--gold-400));
  color: #071325;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 2px;
  border: none;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 12px;
  box-shadow: 0 10px 20px rgba(212, 175, 55, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 15px 30px rgba(212, 175, 55, 0.4);
}

.login-btn:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
}

.login-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 30px;
  text-align: center;
  z-index: 10;
}

.login-footer-links {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 12px;
}

.login-footer-link {
  font-size: 10px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.3);
  letter-spacing: 1px;
  transition: color 0.2s;
}

.login-footer-link:hover {
  color: var(--gold-400);
}

.powered-by {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.2);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.powered-by span {
  color: var(--gold-500);
  font-weight: 800;
}

/* Dashboard Premium Welcome Banner */
.premium-welcome-card {
  background: linear-gradient(-45deg, var(--primary-800), var(--primary-700), #1e293b, var(--primary-800)) !important;
  background-size: 400% 400% !important;
  animation: welcomeGradient 15s ease infinite, welcomeFadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1);
  position: relative;
  overflow: hidden;
  border: none !important;
}

@keyframes welcomeGradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes welcomeFadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

.welcome-shimmer {
  position: absolute;
  top: 0;
  left: -100%;
  width: 50%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.05),
    transparent
  );
  animation: welcomeShimmer 6s infinite;
  transform: skewX(-20deg);
}

@keyframes welcomeShimmer {
  0% { left: -100%; }
  30% { left: 150%; }
  100% { left: 150%; }
}

.pulse-sparkle {
  animation: pulseSparkle 2s ease-in-out infinite;
  display: inline-block;
  vertical-align: middle;
}

@keyframes pulseSparkle {
  0%, 100% { transform: scale(1) rotate(0deg); filter: drop-shadow(0 0 0px var(--gold-400)); }
  50% { transform: scale(1.2) rotate(15deg); filter: drop-shadow(0 0 8px var(--gold-400)); }
}

@media (max-width: 480px) {
  .glass-login-card {
    padding: 32px 24px;
    margin: 20px;
  }
}


/* DatePicker Theme Integration */
.react-datepicker-wrapper { display: block !important; width: 100%; }
.react-datepicker__input-container { display: block !important; }
.react-datepicker { font-family: inherit !important; border-radius: 12px !important; border: 1px solid var(--border) !important; box-shadow: var(--shadow-xl) !important; overflow: hidden; }
.react-datepicker__header { background-color: var(--surface-2) !important; border-bottom: 1px solid var(--border) !important; }
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,mBAAmB;;EAEnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,8BAA8B;EAC9B,oBAAoB;EACpB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;;EAErB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;;EAEjB,4CAA4C;EAC5C,2CAA2C;EAC3C,8CAA8C;EAC9C,8CAA8C;;EAE9C,mDAAmD;EACnD,sBAAsB;EACtB,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA,yDAAyD;AACzD;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,6CAA6C;EAC/C;AACF;;AAEA;EACE,mEAAmE;EACnE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;;EAEnC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;;;EAGE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA,0DAA0D;AAC1D,sBAAsB,UAAU,EAAE,WAAW,EAAE;AAC/C,4BAA4B,4BAA4B,EAAE;AAC1D,4BAA4B,+BAA+B,EAAE,mBAAmB,EAAE;AAClF,kCAAkC,+BAA+B,EAAE;;AAEnE,yDAAyD;AACzD;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;qEAEmE;EACnE,0BAA0B;EAC1B,sCAAsC;EACtC,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,6EAA6E;EAC7E,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,8BAA8B,EAAE;AACzC;AACA;EACE,OAAO,kCAAkC,EAAE;EAC3C,OAAO,4CAA4C,EAAE;AACvD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,qDAAqD;EACrD,sDAAsD;EACtD,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA,wBAAwB;AACxB;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,YAAY;AACd;AACA,sBAAsB,SAAS,EAAE,UAAU,EAAE,yBAAyB,EAAE;AACxE,sBAAsB,YAAY,EAAE,WAAW,EAAE,yBAAyB,EAAE;;AAE5E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,4BAA4B;EAC5B,qCAAqC;AACvC;AACA,uBAAuB,iCAAiC,EAAE;AAC1D,uBAAuB,uCAAuC,EAAE;;AAEhE,iBAAiB;AACjB;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,+DAA+D;AACjE;AACA,yCAAyC,wBAAwB,EAAE;;AAEnE;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qEAAqE;EACrE,cAAc;EACd,YAAY;EACZ,4BAA4B;EAC5B,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,2BAA2B;EAC3B,uEAAuE;AACzE;;;AAGA,uBAAuB;AACvB;;EAEE;;IAEE,sCAAsC;EACxC;;EAEA;IACE,0CAA0C;EAC5C;AACF;;AAEA,sCAAsC;AACtC;EACE,uEAAuE;EACvE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,yDAAyD;EACzD,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,KAAK,gCAAgC,EAAE;EACvC,MAAM,oCAAoC,EAAE;EAC5C,OAAO,kCAAkC,EAAE;AAC7C;;AAEA,2CAA2C;AAC3C;EACE,yCAAyC;AAC3C;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE;IACE,iDAAiD;EACnD;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,kDAAkD;AAClD;EACE,2BAA2B;EAC3B,mBAAmB,EAAE,kCAAkC;EACvD,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,aAAa,kBAAkB,EAAE;;AAEjC;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4BAA4B;EAC5B,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,kDAAkD;EAClD,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,iFAAiF;EACjF,sBAAsB;EACtB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,6BAA6B;AAC/B;;AAEA,sBAAsB,oCAAoC,EAAE;;AAE5D;EACE,WAAW;EACX,YAAY;EACZ,qEAAqE;EACrE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,iCAAiC;EACjC,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;;AAE/B;;AAEA,uDAAuD;AACvD;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,wDAAwD;AACxD;EACE,SAAO;EACP,kBAAkB,EAAE,8BAA8B;EAClD,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;MACI,kBAAkB;EACtB;AACF;;AAEA;EACE;MACI,kBAAkB;EACtB;AACF;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,+EAA+E;EAC/E,+BAA+B;EAC/B,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;AACb;AACA,2BAA2B,gEAAgE,EAAE;AAC7F,2BAA2B,gEAAgE,EAAE;AAC7F,2BAA2B,+DAA+D,EAAE;AAC5F,2BAA2B,8DAA8D,EAAE;AAC3F,2BAA2B,wDAAwD,EAAE;;AAErF;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA,oBAAoB,kCAAkC,GAAG,yBAAyB,EAAE;AACpF,oBAAoB,2BAA2B,SAAS,sBAAsB,EAAE;AAChF,oBAAoB,mBAAmB,iBAAiB,qBAAqB,EAAE;AAC/E,oBAAoB,mBAAmB,iBAAiB,cAAc,EAAE;AACxE,oBAAoB,+BAA+B,IAAI,qBAAqB,EAAE;AAC9E,oBAAoB,gCAAgC,GAAG,oBAAoB,EAAE;;AAE7E;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,sDAAsD;AACtD;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,mCAAmC;EACnC,qCAAqC;EACrC,+BAA+B;AACjC;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,6BAA6B;AAC/B;AACA,sBAAsB,2BAA2B,EAAE,4BAA4B,EAAE;;AAEjF;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,gBAAgB,iBAAiB,EAAE,0BAA0B,EAAE,+BAA+B,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,+BAA+B,EAAE;;AAErM,aAAa,6CAA6C,EAAE,yCAAyC,EAAE,+BAA+B,EAAE;AACxI;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,eAAe;EACf,wCAAwC;AAC1C;AACA,wBAAwB,mBAAmB,EAAE;AAC7C;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,eAAe,EAAE,gBAAgB,EAAE,sBAAsB;AAC3D;AACA,cAAc,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,sBAAsB,EAAE;;AAE5F,aAAa,6CAA6C,EAAE,yCAAyC,EAAE,+BAA+B,EAAE;;AAExI;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;;AAGA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;EAC3E,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,2EAA2E;EAC3E,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,gBAAgB;EAChB,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;EAChB,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;kBAGgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,kEAAkE;EAClE,yCAAyC;EACzC,oDAAoD;EACpD,mBAAmB;AACrB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,4BAA4B,EAAE,4BAA4B;EAC1D,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,0BAA0B;AAC1B;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,mDAAmD;AACrD;;AAEA,0DAA0D;AAC1D;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iDAAiD;EACjD,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2DAA2D;EAC3D,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA,uDAAuD;AACvD;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;AAC1C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oCAAoC;EACpC,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,iGAAiG;EACjG,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;EAC/B,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,6BAA6B;AAC/B;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,YAAY;AACd;;AAEA,uDAAuD;AACvD;EACE;IACE,oDAAoD;EACtD;;EAEA;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,gDAAgD;IAChD,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;IACR,UAAU;IACV,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,wBAAwB;IACxB,iCAAiC;IACjC,4BAA4B;IAC5B,4BAA4B;EAC9B;;EAEA;IACE,oBAAkB;IAClB,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,sDAAsD;IACtD,8BAA8B;EAChC;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;IAC9B,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,iDAAiD;EACjD;;IAEE,WAAW;IACX,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA,8CAA8C;EAC9C;;;;IAIE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA,yDAAyD;EACzD;;;;IAIE,0BAA0B;EAC5B;;EAEA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA,uDAAuD;AACvD;;EAEE;;IAEE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,uDAAuD;AACvD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mEAAmE;EACnE,SAAS;AACX;;AAEA;;EAEE;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,YAAY;EACd;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kCAAkC;AAClC;EACE,gEAAgE;EAChE,uBAAuB;EACvB,uBAAuB;EACvB,+CAA+C;EAC/C,uEAAuE;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC,+CAA+C;EAC/C,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;kBAGgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gEAAgE;EAChE,8CAA8C;EAC9C,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,0CAA0C;EAC1C,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uDAAuD;AACvD;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iDAAiD;IACjD,mBAAmB;EACrB;;EAEA;IACE,kDAAkD;IAClD,sBAAsB;EACxB;;EAEA;IACE,+CAA+C;IAC/C,mBAAmB;EACrB;AACF;;AAEA;;EAEE;;IAEE,wBAAwB;IACxB,YAAY;EACd;;EAEA;IACE,2BAA2B;IAC3B,UAAU;EACZ;AACF;;AAEA,yDAAyD;AACzD;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA,0CAA0C,iBAAiB,EAAE,2BAA2B,EAAE,cAAc,EAAE,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE;;AAEjO;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,YAAY,yBAAyB,EAAE;AACvC,gBAAgB,yBAAyB,EAAE;AAC3C,gBAAgB,yBAAyB,EAAE;;AAE3C,yDAAyD;AACzD;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA,uBAAuB,gCAAgC,EAAE;;AAEzD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB,sBAAsB,EAAE,MAAM,EAAE;EACtD,oBAAoB,WAAW,EAAE,kBAAkB,EAAE,wCAAwC,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,aAAa,EAAE;EACrJ,qBAAqB,mBAAmB,EAAE;AAC5C;;AAEA,uDAAuD;AACvD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;kHACgH;EAChH,sBAAsB;EACtB,2BAA2B;EAC3B,qCAAqC;EACrC,gDAAgD;AAClD;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,OAAO,qBAAqB,EAAE;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;EACE,OAAO,0BAA0B,EAAE;EACnC,KAAK,gCAAgC,EAAE;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,6EAA6E;EAC7E,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,KAAK,8CAA8C,EAAE;EACrD,OAAO,4CAA4C,EAAE;AACvD;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qDAAqD;EACrD,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6EAA6E;EAC7E,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,WAAW,YAAY,EAAE,WAAW,EAAE;EACtC,MAAM,UAAU,EAAE,YAAY,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,qEAAqE;EACrE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,+CAA+C;EAC/C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,mHAAmH;EACnH,qCAAqC;EACrC,8FAA8F;EAC9F,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,6BAA6B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ;;;;;GAKC;EACD,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,UAAU,EAAE;EAClB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW,gCAAgC,EAAE,4CAA4C,EAAE;EAC3F,MAAM,mCAAmC,EAAE,4CAA4C,EAAE;AAC3F;;AAEA;EACE;IACE,kBAAkB;IAClB,YAAY;EACd;AACF;;;AAGA,iCAAiC;AACjC,4BAA4B,yBAAyB,EAAE,WAAW,EAAE;AACpE,qCAAqC,yBAAyB,EAAE;AAChE,oBAAoB,+BAA+B,EAAE,8BAA8B,EAAE,0CAA0C,EAAE,uCAAuC,EAAE,gBAAgB,EAAE;AAC5L,4BAA4B,6CAA6C,EAAE,iDAAiD,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&family=Rajdhani:wght@400;500;600;700&display=swap');\n\n/* ─── NightScan HUD — CSS Variables ─────────────────── */\n:root {\n  --primary-900: #0a1628;\n  --primary-800: #0d1f3c;\n  --primary-700: #122a52;\n  --primary-600: #1a3a5c;\n  --primary-500: #1e4976;\n  --primary-400: #2563a8;\n  --primary-300: #3b82c4;\n  --primary-200: #93c5e8;\n  --primary-100: #dbeafe;\n  --primary-50: #eff6ff;\n  --primary: #1e4976;\n  --primary-dark: #0a1628;\n  --primary-light: #dbeafe;\n  --primary-rgb: 30, 73, 118;\n  --neon-500: #2563a8;\n\n  --gold-500: #c8a437;\n  --gold-400: #d4b44a;\n  --gold-300: #e0c870;\n  --gold-100: #fef9e7;\n\n  --dark: #0a0e1a;\n  --surface: #ffffff;\n  --surface-1: #ffffff;\n  --surface-rgb: 255, 255, 255;\n  --surface-1-rgb: 255, 255, 255;\n  --surface-2: #f8fafd;\n  --surface-3: #f0f4f8;\n  --border: #e2e8f0;\n  --border-2: #cbd5e1;\n  --text-primary: #0f172a;\n  --text-secondary: #475569;\n  --text-muted: #94a3b8;\n\n  --success: #10b981;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n  --info: #3b82f6;\n\n  --radius-sm: 6px;\n  --radius: 10px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n\n  --shadow-sm: 0 1px 3px rgba(10, 22, 40, 0.1);\n  --shadow: 0 4px 12px rgba(10, 22, 40, 0.12);\n  --shadow-lg: 0 8px 30px rgba(10, 22, 40, 0.15);\n  --shadow-xl: 0 20px 60px rgba(10, 22, 40, 0.2);\n\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --sidebar-width: 260px;\n  --glass: rgba(255, 255, 255, 0.7);\n  --glass-border: rgba(255, 255, 255, 0.3);\n}\n\n/* ─── Reset & Base ─────────────────────────────────── */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\nhtml {\n  scroll-behavior: smooth;\n  font-size: 16px;\n  -webkit-text-size-adjust: 100%;\n}\n\n@media (max-width: 768px) {\n  html {\n    font-size: 17px;\n  }\n}\n\n@media (max-width: 480px) {\n  html {\n    font-size: 19px;\n    /* Very large base for absolute readability */\n  }\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: var(--surface-2);\n  color: var(--text-primary);\n  line-height: 1.6;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n  \n  background-attachment: fixed;\n}\n\na {\n  color: inherit;\n  text-decoration: none;\n}\n\nbutton {\n  cursor: pointer;\n  border: none;\n  outline: none;\n}\n\ninput,\nselect,\ntextarea {\n  font-family: inherit;\n  outline: none;\n}\n\nimg {\n  max-width: 100%;\n}\n\n/* ─── Scrollbar ─────────────────────────────────────── */\n::-webkit-scrollbar { width: 4px; height: 4px; }\n::-webkit-scrollbar-track { background: var(--surface-2); }\n::-webkit-scrollbar-thumb { background: rgba(0,212,255,0.3); border-radius: 10px; }\n::-webkit-scrollbar-thumb:hover { background: rgba(0,212,255,0.6); }\n\n/* ─── Login Page — Dark Scanner ────────────────────── */\n.login-page {\n  min-height: 100vh;\n  background: var(--surface-2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  position: relative;\n  overflow: hidden;\n}\n\n/* Animated grid background */\n.login-page::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(0,212,255,0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(0,212,255,0.05) 1px, transparent 1px);\n  background-size: 60px 60px;\n  animation: gridPan 30s linear infinite;\n  z-index: 0;\n}\n\n/* Neon orb glow */\n.login-page::after {\n  content: '';\n  position: absolute;\n  width: 600px;\n  height: 600px;\n  top: -200px;\n  right: -200px;\n  background: radial-gradient(circle, rgba(0,212,255,0.08) 0%, transparent 70%);\n  z-index: 0;\n  animation: orbFloat 12s ease-in-out infinite alternate;\n}\n\n@keyframes gridPan {\n  0%   { background-position: 0 0; }\n  100% { background-position: 60px 60px; }\n}\n@keyframes orbFloat {\n  from { transform: translate(0,0) scale(1); }\n  to   { transform: translate(-40px, 40px) scale(1.1); }\n}\n\n.login-card {\n  position: relative;\n  z-index: 1;\n  background: rgba(6, 14, 30, 0.85);\n  backdrop-filter: blur(30px);\n  -webkit-backdrop-filter: blur(30px);\n  width: 100%;\n  max-width: 460px;\n  padding: 52px 44px;\n  border-radius: var(--radius-xl);\n  box-shadow: 0 0 0 1px var(--border), var(--shadow-xl);\n  animation: fadeInUp 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n  border: 1px solid var(--glass-border);\n  color: var(--text-primary);\n}\n\n/* Corner HUD brackets */\n.login-card::before,\n.login-card::after {\n  content: '';\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  border-color: var(--neon-500);\n  border-style: solid;\n  opacity: 0.8;\n}\n.login-card::before { top: 16px; left: 16px; border-width: 2px 0 0 2px; }\n.login-card::after  { bottom: 16px; right: 16px; border-width: 0 2px 2px 0; }\n\n.login-logo {\n  text-align: center;\n  margin-bottom: 36px;\n}\n.login-logo-container {\n  display: inline-block;\n  margin-bottom: 16px;\n}\n.login-logo h1 {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin-bottom: 6px;\n}\n.login-logo p {\n  color: var(--text-secondary);\n  font-size: 13px;\n}\n.login-info-box {\n  text-align: center;\n  margin-top: 28px;\n  padding: 14px;\n  background: rgba(0,212,255,0.04);\n  border-radius: var(--radius);\n  border: 1px solid var(--glass-border);\n}\n.login-info-box span { color: var(--neon-500) !important; }\n.login-info-box p    { color: var(--text-secondary) !important; }\n\n/* Login inputs */\n.login-card .form-label {\n  color: var(--neon-500);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n}\n.login-card .form-control {\n  background: rgba(0,212,255,0.05);\n  border: 1px solid var(--border);\n  padding: 13px 16px;\n  font-size: 14px;\n  border-radius: var(--radius);\n  transition: all 0.3s ease;\n  color: var(--text-primary);\n}\n.login-card .form-control:focus {\n  background: rgba(0,212,255,0.08);\n  border-color: var(--neon-500);\n  box-shadow: 0 0 0 3px rgba(0,212,255,0.12), var(--neon-glow-sm);\n}\n.login-card .form-control::placeholder { color: var(--text-muted); }\n\n.login-card .btn-primary {\n  height: 52px;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  background: linear-gradient(135deg, var(--neon-600), var(--neon-500));\n  color: #020812;\n  border: none;\n  box-shadow: var(--neon-glow);\n  transition: all 0.3s ease;\n  font-family: 'Rajdhani', sans-serif;\n}\n.login-card .btn-primary:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 0 30px rgba(0,212,255,0.6), 0 0 60px rgba(0,212,255,0.25);\n}\n\n\n/* Premium Animations */\n@keyframes premiumFloat {\n\n  0%,\n  100% {\n    transform: translateY(0) rotate(-5deg);\n  }\n\n  50% {\n    transform: translateY(-12px) rotate(-5deg);\n  }\n}\n\n/* Plus Button Animation Enhancement */\n.plus-btn-animated {\n  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n  cursor: pointer;\n}\n\n.plus-btn-animated:hover {\n  transform: scale(1.15) !important;\n  box-shadow: 0 20px 40px rgba(37, 99, 168, 0.4) !important;\n  filter: brightness(1.2) contrast(1.1);\n}\n\n.plus-btn-animated:hover svg {\n  animation: svgSpin 0.7s cubic-bezier(0.68, -0.55, 0.27, 1.55);\n}\n\n@keyframes svgSpin {\n  0% { transform: rotate(0deg) scale(1); }\n  50% { transform: rotate(180deg) scale(1.4); }\n  100% { transform: rotate(360deg) scale(1); }\n}\n\n/* Subtle continuous rotation for objects */\n.slow-rotate {\n  animation: slowRotate 30s linear infinite;\n}\n\n@keyframes slowRotate {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n@keyframes premiumPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0.4);\n  }\n\n  70% {\n    box-shadow: 0 0 0 20px rgba(var(--primary-rgb), 0);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0);\n  }\n}\n\n@keyframes rotateIcon {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ─── App Layout ───────────────────────────────── */\n.app-layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* ─── Sidebar ───────────────────────────────── */\n.sidebar {\n  width: var(--sidebar-width);\n  background: #0a1628; /* Solid, deep professional blue */\n  border-right: 1px solid rgba(255,255,255,0.05);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  height: 100dvh;\n  z-index: 100;\n  transition: var(--transition);\n  box-shadow: 10px 0 40px rgba(0,0,0,0.3);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 15px 12px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.sidebar-header {\n  padding: 24px 20px;\n  border-bottom: 1px solid rgba(255,255,255,0.05);\n  position: relative;\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.nav-group { margin-bottom: 6px; }\n\n.nav-group-label {\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 2.5px;\n  color: rgba(255,255,255,0.3);\n  padding: 18px 14px 8px;\n  font-family: 'Inter', sans-serif;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  color: rgba(255,255,255,0.6);\n  font-size: 13px;\n  font-weight: 500;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  margin-bottom: 4px;\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n}\n\n.nav-item:hover {\n  background: rgba(212, 175, 55, 0.08);\n  color: var(--gold-300);\n}\n\n.nav-item.active {\n  background: linear-gradient(90deg, rgba(212, 175, 55, 0.15) 0%, transparent 100%);\n  color: var(--gold-400);\n  border-left: 3px solid var(--gold-500);\n  font-weight: 600;\n}\n\n.nav-item.active .nav-icon {\n  color: var(--gold-500);\n  filter: drop-shadow(0 0 8px rgba(212, 175, 55, 0.4));\n}\n\n.nav-item .nav-icon {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  opacity: 0.8;\n  transition: all 0.2s ease;\n}\n\n.nav-item:hover .nav-icon {\n  opacity: 1;\n  transform: scale(1.1);\n}\n\n.nav-item .nav-badge {\n  margin-left: auto;\n  background: var(--gold-500);\n  color: #071325;\n  font-size: 10px;\n  font-weight: 800;\n  padding: 2px 6px;\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(212, 175, 55, 0.3);\n}\n\n.sidebar-footer {\n  padding: 16px 12px;\n  border-top: 1px solid rgba(212, 175, 55, 0.15);\n  background: rgba(255,255,255,0.03);\n}\n\n.sidebar-user {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.sidebar-user:hover { background: rgba(212, 175, 55, 0.08); }\n\n.user-avatar {\n  width: 34px;\n  height: 34px;\n  background: linear-gradient(135deg, var(--gold-500), var(--gold-400));\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #0a1628;\n  font-weight: 700;\n  font-size: 12px;\n  flex-shrink: 0;\n  box-shadow: 0 0 12px rgba(212, 175, 55, 0.25);\n}\n\n.user-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.user-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: white;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-role {\n  font-size: 10px;\n  color: var(--gold-400);\n  opacity: 0.7;\n}\n\n/* ─── Main Content ────────────────────────────────── */\n.main-content {\n  margin-left: var(--sidebar-width);\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: var(--surface-2);\n  transition: var(--transition);\n  \n}\n\n/* ─── Topbar ─────────────────────────────────────── */\n.topbar {\n  background: var(--surface-2);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-bottom: 1px solid var(--glass-border);\n  padding: 12px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  box-shadow: 0 1px 0 var(--border), 0 4px 20px rgba(0,0,0,0.4);\n}\n\n.topbar-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text-primary);\n  font-family: 'Rajdhani', sans-serif;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.topbar-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.topbar-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n}\n\n.topbar-btn-ghost {\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.topbar-btn-ghost:hover {\n  background: var(--surface-3);\n  color: var(--primary-600);\n}\n\n/* ─── Page Content ────────────────────────────────── */\n.page-content {\n  flex: 1;\n  padding: 40px 60px; /* Decent breathable padding */\n  max-width: 1540px;\n  margin: 0 auto;\n  width: 100%;\n  min-height: calc(100vh - 72px);\n  position: relative;\n  transition: var(--transition);\n}\n\n@media (max-width: 1200px) {\n  .page-content {\n      padding: 30px 30px;\n  }\n}\n\n@media (max-width: 768px) {\n  .page-content {\n      padding: 20px 16px;\n  }\n}\n\n/* ─── Stats Cards ───────────────────────────── */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 32px;\n}\n\n.stat-card {\n  background: linear-gradient(135deg, var(--surface-2) 0%, var(--surface-3) 100%);\n  border-radius: var(--radius-lg);\n  padding: 22px;\n  border: 1px solid var(--glass-border);\n  transition: var(--transition);\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n}\n\n/* top accent line */\n.stat-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 2px;\n}\n.stat-card.blue::before  { background: linear-gradient(90deg, var(--neon-500), transparent); }\n.stat-card.gold::before  { background: linear-gradient(90deg, var(--gold-500), transparent); }\n.stat-card.green::before { background: linear-gradient(90deg, var(--success), transparent); }\n.stat-card.red::before   { background: linear-gradient(90deg, var(--danger), transparent); }\n.stat-card.purple::before{ background: linear-gradient(90deg, #8b5cf6, transparent); }\n\n.stat-card:hover {\n  transform: translateY(-3px);\n  box-shadow: var(--shadow);\n  border-color: rgba(0,212,255,0.3);\n}\n\n.stat-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 12px;\n}\n.stat-icon.blue   { background: rgba(37, 99, 168, 0.1);  color: var(--primary-500); }\n.stat-icon.gold   { background: var(--gold-100);        color: var(--gold-400); }\n.stat-icon.green  { background: #ecfdf5;                color: var(--success); }\n.stat-icon.purple { background: #f5f3ff;                color: #7c3aed; }\n.stat-icon.green  { background: rgba(0,255,170,0.1);   color: var(--success); }\n.stat-icon.red    { background: rgba(255,68,102,0.1);  color: var(--danger); }\n\n.stat-number {\n  font-size: 28px;\n  font-weight: 800;\n  color: var(--text-primary);\n  font-family: 'Rajdhani', sans-serif;\n  letter-spacing: 1px;\n}\n\n.stat-label {\n  font-size: 11px;\n  color: var(--text-muted);\n  font-weight: 600;\n  margin-top: 2px;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n}\n\n/* ─── Dashboard extension cards ─────────────────── */\n.glass-panel {\n  background: var(--glass);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  border: 1px solid var(--glass-border);\n  border-radius: var(--radius-lg);\n}\n.premium-stat {\n  background: var(--surface-2);\n  padding: 24px;\n  border-radius: 20px;\n  border: 1px solid var(--glass-border);\n  transition: var(--transition);\n}\n.premium-stat:hover { transform: translateY(-5px); box-shadow: var(--shadow-lg); }\n\n.card {\n  background: white;\n  color: var(--text-primary);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n  border-radius: var(--radius-lg);\n  transition: var(--transition);\n  padding: 24px;\n}\n\n.card:hover {\n  box-shadow: var(--shadow);\n}\n\n\n.insight-card { background: white; color: var(--text-primary); border: 1px solid var(--border); box-shadow: var(--shadow-sm); position: relative; overflow: hidden; border-radius: var(--radius-lg); }\n\n.gold-glow { box-shadow: 0 0 15px rgba(200, 164, 55, 0.15); border: 1px solid rgba(200, 164, 55, 0.3); border-radius: var(--radius-lg); }\n.rank-item {\n  display: flex; align-items: center; gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border-2);\n}\n.rank-item:last-child { border-bottom: none; }\n.rank-number {\n  width: 24px; height: 24px;\n  border-radius: 6px;\n  background: var(--surface-3);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 11px; font-weight: 800; color: var(--neon-500);\n}\n.rank-count { margin-left: auto; font-weight: 700; font-size: 13px; color: var(--neon-500); }\n\n.gold-glow { box-shadow: 0 0 15px rgba(200, 164, 55, 0.15); border: 1px solid rgba(200, 164, 55, 0.3); border-radius: var(--radius-lg); }\n\n.rank-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 10px 0;\n    border-bottom: 1px solid var(--surface-2);\n}\n\n.rank-item:last-child {\n    border-bottom: none;\n}\n\n.compact-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.compact-table th {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  padding: 8px 4px;\n  border-bottom: 1px solid var(--border);\n  text-align: left;\n}\n\n.compact-table td {\n  padding: 8px 4px;\n  border-bottom: 1px solid var(--surface-2);\n  vertical-align: middle;\n}\n\n.compact-table tr:last-child td {\n  border-bottom: none;\n}\n\n.rank-number {\n    width: 24px;\n    height: 24px;\n    border-radius: 6px;\n    background: var(--surface-3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 800;\n    color: var(--text-muted);\n}\n\n.rank-count {\n    margin-left: auto;\n    font-weight: 700;\n    font-size: 13px;\n    color: var(--primary-600);\n}\n\n\n/* ─── Buttons ────────────────────────────────────── */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 18px;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 600;\n  transition: var(--transition);\n  cursor: pointer;\n  border: none;\n  white-space: nowrap;\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--primary-600), var(--primary-500));\n  color: white;\n  box-shadow: 0 4px 12px rgba(26, 58, 92, 0.3);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: linear-gradient(135deg, var(--primary-700), var(--primary-600));\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(26, 58, 92, 0.4);\n}\n\n.btn-gold {\n  background: linear-gradient(135deg, #d4af37 0%, #f1c40f 100%);\n  color: #1a1a1a;\n  font-weight: 700;\n  box-shadow: 0 4px 15px rgba(212, 175, 55, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.btn-gold:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.4);\n  background: linear-gradient(135deg, #f1c40f 0%, #d4af37 100%);\n}\n\n.btn-pdf {\n  background: linear-gradient(135deg, #e74c3c 0%, #c0392b 100%);\n  color: white;\n  font-weight: 700;\n  border: none;\n  box-shadow: 0 4px 15px rgba(231, 76, 60, 0.3);\n  position: relative;\n  overflow: hidden;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  z-index: 1;\n}\n\n.btn-pdf:hover:not(:disabled) {\n  transform: translateY(-3px) scale(1.03);\n  box-shadow: 0 12px 28px rgba(231, 76, 60, 0.45);\n}\n\n.btn-pdf::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(120deg,\n      transparent,\n      rgba(255, 255, 255, 0.4),\n      transparent);\n  transition: all 0.6s ease;\n}\n\n.btn-pdf:hover::before {\n  left: 100%;\n}\n\n.btn-pdf svg {\n  filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.5));\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--primary-600);\n  border: 1.5px solid var(--primary-300);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--primary-50);\n  border-color: var(--primary-500);\n}\n\n.btn-danger {\n  background: var(--danger);\n  color: white;\n}\n\n.btn-danger:hover:not(:disabled) {\n  background: #dc2626;\n  transform: translateY(-1px);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text-secondary);\n}\n\n.btn-ghost:hover {\n  background: var(--surface-3);\n  color: var(--text-primary);\n}\n\n.btn-sm {\n  padding: 6px 12px;\n  font-size: 13px;\n}\n\n.btn-lg {\n  padding: 12px 24px;\n  font-size: 16px;\n}\n\n.btn-circle {\n  border-radius: 50% !important;\n  aspect-ratio: 1 / 1;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n/* ─── Forms ──────────────────────────────────────── */\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  margin-bottom: 6px;\n}\n\n.form-control {\n  width: 100%;\n  padding: 10px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  color: var(--text-primary);\n  background: white;\n  transition: var(--transition);\n}\n\n.form-control:focus {\n  border-color: var(--primary-400);\n  box-shadow: 0 0 0 3px rgba(37, 99, 168, 0.1);\n}\n\n.form-control::placeholder {\n  color: var(--text-muted);\n}\n\n.form-error {\n  font-size: 12px;\n  color: var(--danger);\n  margin-top: 4px;\n}\n\n.form-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  margin-top: 4px;\n}\n\n.form-grid {\n  display: grid;\n  gap: 24px;\n  padding: 0 20px 24px 20px;\n}\n\n.form-grid-2 {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n}\n\n.form-grid-3 {\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n}\n\n.form-section {\n  margin-bottom: 24px;\n}\n\n.form-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary-700);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  padding: 14px 24px;\n  background: linear-gradient(90deg, var(--primary-50), transparent);\n  border-left: 3px solid var(--primary-400);\n  border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n  margin-bottom: 24px;\n}\n\n/* ─── Grid Utilities ────────────────────────────────── */\n.grid-2 {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 24px;\n}\n\n@media (max-width: 900px) {\n  .grid-2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ─── Tables ─────────────────────────────────────── */\n.table-responsive {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-container {\n  background: white;\n  border-radius: var(--radius); box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\n.table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--border-2);\n  background: white;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background: var(--surface-2);\n}\n\nth {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-muted);\n  white-space: nowrap;\n  border-bottom: 2px solid var(--border);\n}\n\ntd {\n  padding: 14px 16px;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border-2);\n  color: var(--text-primary);\n}\n\ntbody tr:hover {\n  background: var(--surface-2);\n}\n\ntbody tr:last-child td {\n  border-bottom: none;\n}\n\n.table-actions {\n  display: flex;\n  gap: 4px;\n}\n\n.table-actions .btn-ghost {\n  padding: 8px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.table-actions .btn-ghost svg,\n.table-actions .btn-ghost i {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n}\n\n.action-view {\n  color: var(--text-secondary);\n}\n\n.action-view:hover {\n  background: var(--primary-50) !important;\n  color: var(--primary-500) !important;\n}\n\n.action-edit {\n  color: var(--text-secondary);\n}\n\n.action-edit:hover {\n  background: #fef3c7 !important;\n  color: #d97706 !important;\n}\n\n.action-invoice {\n  color: var(--primary-600);\n}\n\n.action-invoice:hover {\n  background: #dcfce7 !important;\n  color: var(--success) !important;\n}\n\n.action-pdf {\n  color: var(--primary-600);\n}\n\n.action-pdf:hover {\n  background: var(--primary-100) !important;\n  color: var(--primary-800) !important;\n}\n\n.action-export {\n  color: var(--primary-700);\n}\n\n.action-export:hover {\n  background: var(--gold-100) !important;\n  color: #b45309 !important;\n}\n\n.action-delete {\n  color: var(--danger);\n}\n\n.action-delete:hover {\n  background: #fee2e2 !important;\n  color: #b91c1c !important;\n}\n\n/* ─── Badges / Status ────────────────────────────── */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.badge-blue {\n  background: var(--primary-100);\n  color: var(--primary-600);\n}\n\n.badge-gold {\n  background: var(--gold-100);\n  color: #8a6c00;\n}\n\n.badge-green {\n  background: #d1fae5;\n  color: #065f46;\n}\n\n.badge-red {\n  background: #fee2e2;\n  color: #991b1b;\n}\n\n.badge-gray {\n  background: var(--surface-3);\n  color: var(--text-secondary);\n}\n\n.badge-orange {\n  background: #fff7ed;\n  color: #9a3412;\n}\n\n/* ─── Modals ─────────────────────────────────────── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 22, 40, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n  animation: fadeIn 0.2s ease;\n}\n\n.modal {\n  background: white;\n  border-radius: var(--radius-lg);\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: var(--shadow-xl);\n  animation: slideUp 0.3s ease;\n}\n\n.modal-lg {\n  max-width: 900px;\n}\n\n.modal-xxl {\n  max-width: 1700px;\n  width: 96vw;\n}\n\n.premium-grid-layout {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 25px;\n}\n\n@media (max-width: 1400px) {\n  .premium-grid-layout {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 900px) {\n  .premium-grid-layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Premium Form Elements */\n.premium-card {\n  background: var(--surface-1);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.premium-card:hover {\n  box-shadow: var(--shadow-md);\n  border-color: var(--primary-light);\n}\n\n.premium-header {\n  padding: 12px 16px;\n  background: var(--surface-1);\n  border-bottom: 1px solid var(--border-2);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.premium-header i,\n.premium-header svg {\n  color: var(--primary);\n  filter: drop-shadow(0 2px 4px rgba(var(--primary-rgb), 0.2));\n}\n\n.premium-header span {\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text-primary);\n}\n\n.premium-input-group {\n  position: relative;\n  margin-bottom: 0;\n}\n\n.premium-input-group .form-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-muted);\n  margin-bottom: 4px;\n  display: block;\n}\n\n.premium-input-group .form-control {\n  border-radius: 8px;\n  border: 1.5px solid var(--border);\n  background: var(--surface-2);\n  padding: 8px 12px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.premium-input-group .form-control:focus {\n  border-color: var(--primary);\n  background: var(--surface-1);\n  box-shadow: 0 0 0 4px rgba(var(--primary-rgb), 0.1);\n}\n\n/* ─── Toggle Switch ─────────────────────────────────── */\n.form-toggle {\n  width: 44px;\n  height: 22px;\n  background: #cbd5e1;\n  border-radius: 100px;\n  position: relative;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: pointer;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(0,0,0,0.05);\n}\n\n.form-toggle.active {\n  background: var(--gold-500);\n}\n\n.toggle-dot {\n  width: 16px;\n  height: 16px;\n  background: #ffffff;\n  border-radius: 50%;\n  position: absolute;\n  top: 2px;\n  left: 3px;\n  transition: all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n  box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n}\n\n.form-toggle.active .toggle-dot {\n  left: calc(100% - 19px);\n}\n\n.glass-modal {\n  backdrop-filter: blur(15px);\n  background: rgba(var(--surface-1-rgb), 0.8);\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 18px 24px;\n  border-bottom: 1px solid var(--border-2);\n  flex-shrink: 0;\n}\n\n.modal-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--primary-800);\n}\n\n.modal-body {\n  padding: 24px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.modal-footer {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 16px 24px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.modal-close {\n  background: var(--surface-3);\n  color: var(--text-secondary);\n  border: none;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.modal-close:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n/* ─── Search & Filters ────────────────────────────── */\n.search-box {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.search-box input {\n  padding: 8px 14px 8px 36px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  background: var(--surface-2);\n  width: 260px;\n  transition: var(--transition);\n}\n\n.search-box input:focus {\n  border-color: var(--primary-400);\n  background: white;\n  width: 320px;\n  box-shadow: 0 0 0 3px rgba(37, 99, 168, 0.1);\n}\n\n.search-icon {\n  position: absolute;\n  left: 10px;\n  color: var(--text-muted);\n}\n\n/* ─── Pieces Table (Rapport) ─────────────────────── */\n.pieces-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n}\n\n.pieces-table th {\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.9);\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  text-align: left;\n}\n\n.pieces-table td {\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border-2);\n}\n\n.pieces-table tbody tr:hover {\n  background: var(--primary-50);\n}\n\n.pieces-input {\n  width: 100%;\n  padding: 6px 8px;\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  font-size: 13px;\n  background: transparent;\n}\n\n.pieces-input:focus {\n  border-color: var(--primary-400);\n  background: white;\n}\n\n.pieces-subtotal {\n  font-weight: 700;\n  color: var(--primary-600);\n  font-size: 14px;\n}\n\n/* ─── Photo Upload ───────────────────────────────── */\n.dropzone {\n  border: 2px dashed var(--border-2);\n  border-radius: var(--radius);\n  padding: 30px;\n  text-align: center;\n  cursor: pointer;\n  transition: var(--transition);\n  background: var(--surface-2);\n}\n\n.dropzone:hover,\n.dropzone.active {\n  border-color: var(--primary-400);\n  background: var(--primary-50);\n}\n\n.photos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.photo-item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: var(--radius-sm);\n  overflow: hidden;\n  border: 2px solid var(--border);\n}\n\n.photo-item img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.photo-delete {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  background: rgba(239, 68, 68, 0.9);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 22px;\n  height: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 12px;\n}\n\n/* ─── Empty State ────────────────────────────────── */\n.empty-state {\n  text-align: center;\n  padding: 48px 24px;\n  color: var(--text-muted);\n}\n\n.empty-state-icon {\n  font-size: 48px;\n  margin-bottom: 12px;\n  opacity: 0.5;\n}\n\n.empty-state h3 {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  margin-bottom: 6px;\n}\n\n.empty-state p {\n  font-size: 14px;\n}\n\n/* ─── Loading ────────────────────────────────────── */\n.loading-spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px;\n}\n\n.spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid var(--border);\n  border-top-color: var(--primary-500);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n.skeleton {\n  background: linear-gradient(90deg, var(--surface-3) 25%, var(--border) 50%, var(--surface-3) 75%);\n  background-size: 400% 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: var(--radius-sm);\n}\n\n/* ─── Pagination ─────────────────────────────────── */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 16px;\n}\n\n.page-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm);\n  font-size: 14px;\n  font-weight: 500;\n  transition: var(--transition);\n  border: 1px solid var(--border);\n  background: white;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.page-btn:hover {\n  border-color: var(--primary-400);\n  color: var(--primary-500);\n  background: var(--primary-50);\n}\n\n.page-btn.active {\n  background: var(--primary-600);\n  color: white;\n  border-color: var(--primary-600);\n}\n\n.page-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ─── Tabs ──────────────────────────────────────── */\n.tabs {\n  display: flex;\n  border-bottom: 2px solid var(--border);\n  margin-bottom: 20px;\n}\n\n.tab {\n  padding: 10px 18px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -2px;\n  transition: var(--transition);\n}\n\n.tab:hover {\n  color: var(--primary-600);\n}\n\n.tab.active {\n  color: var(--primary-600);\n  border-bottom-color: var(--primary-500);\n  background: var(--primary-50);\n}\n\n/* ─── Dashboard Quick Actions ─────────────────────── */\n.quick-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.quick-action-card {\n  background: white;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  text-align: center;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.quick-action-card:hover {\n  border-color: var(--primary-400);\n  background: var(--primary-50);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow);\n}\n\n.quick-action-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: var(--radius);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n}\n\n.quick-action-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n/* ─── Animations ─────────────────────────────────── */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes shimmer {\n  to {\n    background-position: -400% 0;\n  }\n}\n\n/* ─── Mobile Overlay ─────────────────────────────── */\n.sidebar-overlay {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 99;\n}\n\n.menu-toggle {\n  display: none;\n  background: transparent;\n  border: none;\n  color: var(--text-secondary);\n  cursor: pointer;\n  padding: 4px;\n}\n\n/* ─── Responsive ─────────────────────────────────── */\n@media (max-width: 1024px) {\n  .form-grid-3 {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n\n  .grid-3 {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    transform: translateX(-100%);\n    z-index: 200;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n\n  .sidebar-overlay {\n    display: block;\n  }\n\n  .main-content {\n    margin-left: 0;\n    padding-top: 0;\n  }\n\n  .menu-toggle {\n    display: flex;\n  }\n\n  .form-grid-2,\n  .form-grid-3,\n  .grid-2,\n  .grid-3 {\n    grid-template-columns: minmax(0, 1fr) !important;\n    gap: 12px !important;\n  }\n\n  .search-box input {\n    width: 100%;\n  }\n\n  .stats-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    padding: 0;\n    margin-bottom: 16px;\n  }\n\n  .stat-card {\n    padding: 16px;\n  }\n\n  .topbar-date {\n    display: none;\n  }\n\n  .header-custom-actions {\n    margin-right: -10px;\n    display: flex;\n    align-items: center;\n  }\n\n  .sidebar {\n    height: 100dvh !important;\n    display: flex !important;\n    flex-direction: column !important;\n    padding-bottom: 0 !important;\n    /* No padding here anymore */\n  }\n\n  .sidebar-nav {\n    flex: 1 !important;\n    overflow-y: auto !important;\n    -webkit-overflow-scrolling: touch !important;\n  }\n\n  .sidebar-footer {\n    padding-bottom: max(12px, env(safe-area-inset-bottom));\n    /* Support for modern phones */\n  }\n\n\n  .stat-number {\n    font-size: 20px;\n  }\n\n  .page-content {\n    padding: 10px;\n  }\n\n  .quick-actions-grid {\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n  }\n\n  .modal {\n    max-width: 95%;\n    max-height: 90vh;\n    border-radius: var(--radius);\n  }\n\n  .modal-overlay {\n    padding: 10px;\n    align-items: center;\n  }\n\n  .table-container {\n    margin: 0 -12px;\n    padding: 0 12px;\n    width: calc(100% + 24px);\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  table {\n    min-width: 500px;\n  }\n\n  .card-header {\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n}\n\n@media (max-width: 480px) {\n  .stats-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .topbar {\n    padding: 12px 16px;\n    height: 64px;\n  }\n\n  .topbar-title {\n    font-size: 18px;\n  }\n\n  .topbar-actions {\n    display: flex;\n    align-items: center;\n  }\n\n  th,\n  td {\n    padding: 12px 10px;\n    font-size: 13px;\n  }\n\n  .btn {\n    padding: 14px 20px;\n    font-size: 15px;\n    width: 100%;\n    justify-content: center;\n    min-height: 48px;\n  }\n\n  /* Prevent topbar buttons from being full width */\n  .topbar-actions .btn,\n  .header-custom-actions .btn {\n    width: auto;\n    min-height: unset;\n    padding: 8px;\n  }\n\n  .card {\n    padding: 16px;\n    margin-bottom: 16px;\n  }\n\n  .card-title {\n    font-size: 16px;\n  }\n\n  .form-label {\n    font-size: 14px;\n    margin-bottom: 8px;\n    font-weight: 700;\n  }\n\n  .form-control {\n    padding: 12px 16px;\n    font-size: 15px;\n    border-width: 2px;\n  }\n\n  .quick-actions-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .login-card {\n    padding: 40px 24px;\n    border-radius: 0;\n    min-height: 100vh;\n  }\n\n  .login-logo p {\n    font-size: 15px;\n  }\n\n  /* Universal minimums for mobile readability */\n  label,\n  .form-label,\n  .nav-group-label,\n  .card-title {\n    font-size: 14px !important;\n  }\n\n  .badge,\n  .text-sm,\n  .text-muted {\n    font-size: 13px !important;\n  }\n\n  /* Fix small fonts in inline styles often used in cards */\n  div[style*=\"font-size: 11px\"],\n  div[style*=\"font-size: 10px\"],\n  span[style*=\"font-size: 11px\"],\n  span[style*=\"font-size: 10px\"] {\n    font-size: 13px !important;\n  }\n\n  div[style*=\"font-size: 13px\"],\n  div[style*=\"font-size: 12px\"] {\n    font-size: 15px !important;\n  }\n}\n\n/* ─── Print ──────────────────────────────────────── */\n@media print {\n\n  .sidebar,\n  .topbar {\n    display: none;\n  }\n\n  .main-content {\n    margin-left: 0;\n  }\n}\n\n/* ─── Utility Classes ────────────────────────────── */\n.flex {\n  display: flex;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@media (max-width: 768px) {\n  .flex-between {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 16px;\n  }\n}\n\n.gap-2 {\n  gap: 8px;\n}\n\n.gap-3 {\n  gap: 12px;\n}\n\n.gap-4 {\n  gap: 16px;\n}\n\n.mb-4 {\n  margin-bottom: 16px;\n}\n\n.mb-6 {\n  margin-bottom: 24px;\n}\n\n.mt-4 {\n  margin-top: 16px;\n}\n\n.text-sm {\n  font-size: 12px;\n}\n\n.text-muted {\n  color: var(--text-muted);\n}\n\n.text-success {\n  color: var(--success);\n}\n\n.text-danger {\n  color: var(--danger);\n}\n\n.text-gold {\n  color: var(--gold-500);\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.grid-2 {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  gap: 16px;\n}\n\n.grid-3 {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);\n  gap: 16px;\n}\n\n@media (max-width: 480px) {\n\n  .grid-2,\n  .grid-3 {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 0.8;\n  }\n\n  50% {\n    transform: scale(1.4);\n    opacity: 0.3;\n  }\n\n  100% {\n    transform: scale(1.8);\n    opacity: 0;\n  }\n}\n\n@keyframes slideInDown {\n  from {\n    transform: translateY(-10px);\n    opacity: 0;\n  }\n\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.template-suggestions-container {\n  animation: slideInDown 0.3s ease-out;\n}\n\n/* ─── IA Style Enhancements ─── */\n.btn-ia {\n  background: linear-gradient(135deg, #6366f1, #a855f7) !important;\n  color: white !important;\n  border: none !important;\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.35);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;\n  position: relative;\n  overflow: hidden;\n  z-index: 1;\n}\n\n.btn-ia:hover:not(:disabled) {\n  transform: translateY(-2px) scale(1.02);\n  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.45);\n  filter: brightness(1.1);\n}\n\n.btn-ia:active:not(:disabled) {\n  transform: translateY(1px) scale(0.98);\n}\n\n.btn-ia::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(120deg,\n      transparent,\n      rgba(255, 255, 255, 0.3),\n      transparent);\n  transition: all 0.6s;\n  z-index: -1;\n}\n\n.btn-ia:hover::before {\n  left: 100%;\n}\n\n.badge-ia-cool {\n  background: linear-gradient(135deg, #6366f1, #8b5cf6) !important;\n  box-shadow: 0 2px 10px rgba(99, 102, 241, 0.4);\n  animation: ia-pulse 2s infinite ease-in-out;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes ia-pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(1.05);\n    opacity: 0.9;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.spinner-ia {\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top: 2px solid #ffffff;\n  border-radius: 50%;\n  width: 14px;\n  height: 14px;\n  animation: spin-ia 0.8s linear infinite;\n}\n\n@keyframes spin-ia {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* ─── Modal / Dialog ─────────────────────────────── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9000;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  padding: 24px;\n}\n\n.modal {\n  background: white;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-xl);\n  width: 100%;\n  max-width: 500px;\n  position: relative;\n}\n\n/* ─── Animations ─────────────────────────────────── */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px) scale(0.97);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n@keyframes imgFadeIn {\n  from {\n    opacity: 0;\n    transform: scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes premiumPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0.4);\n    transform: scale(1);\n  }\n\n  50% {\n    box-shadow: 0 0 0 15px rgba(var(--primary-rgb), 0);\n    transform: scale(1.02);\n  }\n\n  100% {\n    box-shadow: 0 0 0 0 rgba(var(--primary-rgb), 0);\n    transform: scale(1);\n  }\n}\n\n@keyframes pointingArrow {\n\n  0%,\n  100% {\n    transform: translateX(0);\n    opacity: 0.8;\n  }\n\n  50% {\n    transform: translateX(12px);\n    opacity: 1;\n  }\n}\n\n/* ─── Collapsed Sidebar ────────────────────────────── */\n:root {\n  --sidebar-collapsed-width: 80px;\n}\n\n.sidebar.collapsed {\n  width: var(--sidebar-collapsed-width);\n}\n\n.sidebar.collapsed .sidebar-header {\n  padding: 20px 0 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar.collapsed .nav-group-label {\n  display: none;\n}\n\n.sidebar.collapsed .nav-item {\n  justify-content: center;\n  padding: 11px 0;\n  margin-bottom: 8px;\n}\n\n.sidebar.collapsed .nav-item span {\n  display: none;\n}\n\n.sidebar.collapsed .nav-item .nav-badge { margin-left: auto; background: var(--gold-500); color: #071325; font-size: 9px; font-weight: 800; padding: 2px 5px; border-radius: 10px; box-shadow: 0 0 10px rgba(212, 175, 55, 0.3); }\n\n.sidebar.collapsed .sidebar-user {\n  justify-content: center;\n  padding: 8px 0;\n}\n\n.sidebar.collapsed .user-info,\n.sidebar.collapsed .sidebar-user>svg {\n  display: none;\n}\n\n.app-layout:has(.sidebar.collapsed) .main-content {\n  margin-left: var(--sidebar-collapsed-width);\n}\n\n@media (max-width: 768px) {\n  .app-layout:has(.sidebar.collapsed) .main-content {\n    margin-left: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .desktop-collapse-btn {\n    display: none !important;\n  }\n}\n\n/* ─── Table Actions ────────────────────────────────── */\n.table-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.table-actions .btn-ghost {\n  padding: 6px;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.table-actions .btn-ghost:hover {\n  background: var(--surface-3);\n  transform: translateY(-1px);\n}\n\n.text-red { color: #ef4444 !important; }\n.text-warning { color: #f59e0b !important; }\n.text-success { color: #10b981 !important; }\n\n/* ─── Premium Settings Redesign ────────────────────── */\n.settings-container {\n  display: flex;\n  gap: 32px;\n  background: white;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow);\n  min-height: 600px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n}\n\n.settings-sidebar {\n  width: 280px;\n  background: #f8fafc;\n  border-right: 1px solid var(--border);\n  padding: 24px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.settings-nav-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n  border-radius: 12px;\n  color: var(--text-secondary);\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.settings-nav-item:hover {\n  background: var(--primary-50);\n  color: var(--primary-600);\n}\n\n.settings-nav-item.active {\n  background: var(--surface-2);\n  color: var(--gold-300);\n  box-shadow: 0 4px 12px rgba(10, 22, 40, 0.2);\n}\n\n.settings-content {\n  flex: 1;\n  padding: 32px;\n  overflow-y: auto;\n  background: #fff;\n}\n\n.settings-section-header {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--primary-50);\n}\n\n.settings-title {\n  font-size: 22px;\n  font-weight: 800;\n  color: var(--primary-900);\n  letter-spacing: -0.5px;\n}\n\n.settings-card {\n  background: white;\n  border-radius: 16px;\n  border: 1px solid var(--border);\n  padding: 24px;\n  margin-bottom: 24px;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.03);\n  transition: transform 0.2s ease;\n}\n\n.settings-card:hover { border-color: var(--primary-200); }\n\n.settings-card-title {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--primary-800);\n  margin-bottom: 20px;\n}\n\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n}\n\n.badge-ia-premium {\n  background: linear-gradient(135deg, #6366f1, #a855f7);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 10px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.btn-save-floating {\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  padding: 16px 32px;\n  border-radius: 50px;\n  box-shadow: var(--shadow-lg);\n  z-index: 1000;\n  animation: slideUp 0.5s ease;\n}\n\n@media (max-width: 1024px) {\n  .settings-container { flex-direction: column; gap: 0; }\n  .settings-sidebar { width: 100%; border-right: none; border-bottom: 1px solid var(--border-2); flex-direction: row; overflow-x: auto; padding: 12px; }\n  .settings-nav-item { white-space: nowrap; }\n}\n\n/* ─── Premium Login Redesign (Google Stitch) ─────── */\n.login-page-v2 {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n  background: #071325;\n}\n\n.login-bg-hero {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background: linear-gradient(rgba(7, 19, 37, 0.7), rgba(7, 19, 37, 0.95)), \n              url('https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&q=80&w=2070');\n  background-size: cover;\n  background-position: center;\n  filter: contrast(1.1) brightness(0.8);\n  animation: bg-zoom 60s infinite alternate linear;\n}\n\n@keyframes bg-zoom {\n  0% { transform: scale(1); }\n  100% { transform: scale(1.1); }\n}\n\n.login-bg-overlay {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(circle at center, transparent 0%, rgba(7, 19, 37, 0.8) 100%);\n}\n\n.login-glow-1 {\n  position: absolute;\n  top: 20%;\n  left: 10%;\n  width: 400px;\n  height: 400px;\n  background: rgba(212, 175, 55, 0.05);\n  border-radius: 50%;\n  filter: blur(100px);\n  animation: float-slow 15s infinite alternate;\n}\n\n.login-glow-2 {\n  position: absolute;\n  bottom: 20%;\n  right: 10%;\n  width: 400px;\n  height: 400px;\n  background: rgba(212, 175, 55, 0.05);\n  border-radius: 50%;\n  filter: blur(100px);\n  animation: float-slow 12s infinite alternate-reverse;\n}\n\n@keyframes float-slow {\n  from { transform: translate(0, 0); }\n  to { transform: translate(40px, 40px); }\n}\n\n.glass-login-card {\n  position: relative;\n  z-index: 10;\n  width: 100%;\n  max-width: 440px;\n  background: rgba(10, 22, 40, 0.75);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(212, 175, 55, 0.15);\n  border-radius: 24px;\n  padding: 48px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.5), 0 0 30px rgba(212, 175, 55, 0.05);\n  animation: slideUpFade 0.8s cubic-bezier(0.4, 0, 0.2, 1);\n  overflow: hidden;\n}\n\n.glass-login-card::after {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: linear-gradient(\n    45deg,\n    transparent 45%,\n    rgba(212, 175, 55, 0.1) 50%,\n    transparent 55%\n  );\n  transform: rotate(45deg);\n  animation: shimmer 4s infinite;\n  pointer-events: none;\n}\n\n@keyframes shimmer {\n  0% { transform: translate(-30%, -30%) rotate(45deg); }\n  100% { transform: translate(30%, 30%) rotate(45deg); }\n}\n\n@keyframes slideUpFade {\n  from { opacity: 0; transform: translateY(30px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.login-brand {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-brand-logo {\n    display: flex;\n    justify-content: center;\n    margin-bottom: -15px;\n}\n\n.login-brand h1 {\n  font-size: 32px;\n  font-weight: 800;\n  color: var(--gold-400);\n  letter-spacing: 4px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n  filter: drop-shadow(0 0 10px rgba(212, 175, 55, 0.3));\n  transition: filter 0.3s ease;\n}\n\n.login-brand:hover h1 {\n  filter: drop-shadow(0 0 20px rgba(212, 175, 55, 0.6));\n}\n\n.login-brand-line {\n  height: 1px;\n  width: 60px;\n  background: linear-gradient(90deg, transparent, var(--gold-500), transparent);\n  margin: 0 auto 12px;\n  animation: pulse-line 3s infinite ease-in-out;\n}\n\n@keyframes pulse-line {\n  0%, 100% { opacity: 0.5; width: 60px; }\n  50% { opacity: 1; width: 100px; }\n}\n\n.login-brand p {\n  font-size: 10px;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.4);\n  font-weight: 600;\n}\n\n.login-form-group {\n  margin-bottom: 24px;\n}\n\n.login-label {\n  display: block;\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n  color: rgba(255, 255, 255, 0.5);\n  margin-bottom: 8px;\n  font-weight: 700;\n}\n\n.login-input-wrapper {\n  position: relative;\n}\n\n.login-input-icon {\n  position: absolute;\n  left: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--gold-500);\n  opacity: 0.6;\n}\n\n.login-input {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 14px 14px 14px 48px;\n  color: white;\n  font-size: 15px;\n  transition: all 0.3s;\n  outline: none;\n}\n\n.login-input:focus {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: var(--gold-500);\n  box-shadow: 0 0 15px rgba(212, 175, 55, 0.1);\n}\n\n.login-btn {\n  width: 100%;\n  padding: 16px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, var(--gold-500), var(--gold-400));\n  color: #071325;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s;\n  margin-top: 12px;\n  box-shadow: 0 10px 20px rgba(212, 175, 55, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.login-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 15px 30px rgba(212, 175, 55, 0.4);\n}\n\n.login-btn:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.login-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  padding: 30px;\n  text-align: center;\n  z-index: 10;\n}\n\n.login-footer-links {\n  display: flex;\n  justify-content: center;\n  gap: 24px;\n  margin-bottom: 12px;\n}\n\n.login-footer-link {\n  font-size: 10px;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.3);\n  letter-spacing: 1px;\n  transition: color 0.2s;\n}\n\n.login-footer-link:hover {\n  color: var(--gold-400);\n}\n\n.powered-by {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.2);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.powered-by span {\n  color: var(--gold-500);\n  font-weight: 800;\n}\n\n/* Dashboard Premium Welcome Banner */\n.premium-welcome-card {\n  background: linear-gradient(-45deg, var(--primary-800), var(--primary-700), #1e293b, var(--primary-800)) !important;\n  background-size: 400% 400% !important;\n  animation: welcomeGradient 15s ease infinite, welcomeFadeIn 0.8s cubic-bezier(0.16, 1, 0.3, 1);\n  position: relative;\n  overflow: hidden;\n  border: none !important;\n}\n\n@keyframes welcomeGradient {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n@keyframes welcomeFadeIn {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.welcome-shimmer {\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.05),\n    transparent\n  );\n  animation: welcomeShimmer 6s infinite;\n  transform: skewX(-20deg);\n}\n\n@keyframes welcomeShimmer {\n  0% { left: -100%; }\n  30% { left: 150%; }\n  100% { left: 150%; }\n}\n\n.pulse-sparkle {\n  animation: pulseSparkle 2s ease-in-out infinite;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n@keyframes pulseSparkle {\n  0%, 100% { transform: scale(1) rotate(0deg); filter: drop-shadow(0 0 0px var(--gold-400)); }\n  50% { transform: scale(1.2) rotate(15deg); filter: drop-shadow(0 0 8px var(--gold-400)); }\n}\n\n@media (max-width: 480px) {\n  .glass-login-card {\n    padding: 32px 24px;\n    margin: 20px;\n  }\n}\n\n\n/* DatePicker Theme Integration */\n.react-datepicker-wrapper { display: block !important; width: 100%; }\n.react-datepicker__input-container { display: block !important; }\n.react-datepicker { font-family: inherit !important; border-radius: 12px !important; border: 1px solid var(--border) !important; box-shadow: var(--shadow-xl) !important; overflow: hidden; }\n.react-datepicker__header { background-color: var(--surface-2) !important; border-bottom: 1px solid var(--border) !important; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
